import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";

export type APSchoolGroupStudent = {
  id?: number | string;
  name?: string;
  last_name?: string;
  last_name_2?: string;
  birth_date?: string;
  birthDate?: string;
  fecha_nacimiento?: string;
  curp?: string;
  rfc?: string;
  sex?: string;
  sexo?: string;
  postal_code?: string;
  codigo_postal?: string;
  name_beneficiary?: string;
  last_name_beneficiary?: string;
  last_name_2_beneficiary?: string;
};

export type APSchoolGroup = {
  id: number | string;
  name: string;
  students?: APSchoolGroupStudent[];
};

type APSchoolGroupsState = {
  groups: APSchoolGroup[];
  loading: boolean;
};

export const getAPSchoolGroups = createAsyncThunk<
  { data: any },
  { clientId: number | string; params?: Record<string, any> }
>("apSchool/groups", async ({ clientId, params }) => {
  const response = await api.get(`api/student_groups?client_id=${clientId}`, {
    params
  });
  return { data: response.data };
});

export const createAPSchoolGroup = createAsyncThunk<
  { data: any },
  { clientId: number | string; name: string; students: Array<number | string> }
>("apSchool/groups/create", async (payload) => {
  const response = await api.post("api/student_groups", {
    client_id: payload.clientId,
    name: payload.name,
    students: payload.students
  });
  return { data: response.data };
});

export const updateAPSchoolGroup = createAsyncThunk<
  { data: any },
  { groupId: number | string; clientId: number | string; name: string; students: Array<number | string> }
>("apSchool/groups/update", async (payload) => {
  const response = await api.put(`api/student_groups/${payload.groupId}`, {
    client_id: payload.clientId,
    name: payload.name,
    students: payload.students
  });
  return { data: response.data };
});

export const deleteAPSchoolGroup = createAsyncThunk<
  { data: any },
  { groupId: number | string; clientId?: number | string }
>("apSchool/groups/delete", async ({ groupId, clientId }, { dispatch }) => {
  const response = await api.delete(`api/student_groups/${groupId}`);
  if (clientId) {
    dispatch(getAPSchoolGroups({ clientId }));
  }
  return { data: response.data };
});

const initialState: APSchoolGroupsState = {
  groups: [],
  loading: false
};

const apSchoolGroupsSlice = createSlice({
  name: "apSchoolGroups",
  initialState,
  reducers: {
    clearAPSchoolGroups: (state) => {
      state.groups = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAPSchoolGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAPSchoolGroups.fulfilled, (state, action) => {
      const payload = action.payload.data;
      const groups = Array.isArray(payload?.data?.data)
        ? payload.data.data
        : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.groups)
        ? payload.groups
        : Array.isArray(payload)
        ? payload
        : [];
      state.groups = groups;
      state.loading = false;
    });
    builder.addCase(getAPSchoolGroups.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { clearAPSchoolGroups } = apSchoolGroupsSlice.actions;

export default apSchoolGroupsSlice.reducer;
